// @ts-nocheck
import _ from 'lodash';
import { createContext, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Snackbar } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { useIfMounted } from '../hooks';

export const AlertSeverity = {
  Info: 'info',
  Success: 'success',
  Warning: 'warning',
  Error: 'error',
};

export const AlertContext = createContext();

function AlertComponent(props) {
  const { open, title, message, severity, autoHideDuration, onClose } = props;

  return (
    <Snackbar open={open} autoHideDuration={autoHideDuration} onClose={onClose}>
      <Alert variant="filled" severity={severity} onClose={onClose}>
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </Snackbar>
  );
}

function AlertProvider(props) {
  const [alertOptions, setAlertOptions] = useState({
    open: false,
    title: '',
    message: '',
    severity: AlertSeverity.Info,
  });
  const ifMounted = useIfMounted();

  const showAlert = useCallback(
    ({ title, message, severity = AlertSeverity.Info }) => {
      if (alertOptions.open) {
        setAlertOptions(prevAlertOptions => ({
          ...prevAlertOptions,
          open: false,
        }));
        _.delay(() => {
          ifMounted(() =>
            setAlertOptions(prevAlertOptions => ({
              ...prevAlertOptions,
              title,
              message,
              severity,
              open: true,
            }))
          );
        }, 250);
      } else {
        setAlertOptions(prevAlertOptions => ({
          ...prevAlertOptions,
          title,
          message,
          severity,
          open: true,
        }));
      }
    },
    [alertOptions.open, ifMounted]
  );

  const hideAlert = useCallback((_event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertOptions(prevAlertOptions => ({
      ...prevAlertOptions,
      open: false,
    }));
  }, []);

  const getAlertDuration = () => {
    switch (alertOptions.severity) {
      case AlertSeverity.Error:
      case AlertSeverity.Warning:
        return 16000;
      default:
        return 4000;
    }
  };

  const { children } = props;
  const { open, title, message, severity } = alertOptions;

  return (
    <AlertContext.Provider value={{ showAlert, hideAlert }}>
      {children}
      <AlertComponent
        open={open}
        title={title}
        message={message}
        severity={severity}
        autoHideDuration={getAlertDuration()}
        onClose={hideAlert}
      />
    </AlertContext.Provider>
  );
}

AlertComponent.defaultProps = {
  title: undefined,
  message: undefined,
};

AlertComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  severity: PropTypes.oneOf(['info', 'success', 'warning', 'error']).isRequired,
  autoHideDuration: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};

AlertProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AlertProvider;
